import useGetReminders from "../../reminders/api/useGetReminders";

export default function useGetProviderReminders(providerId: string, is_completed?: boolean, enabled = true) {
  return useGetReminders(
    { provider_id: providerId, is_completed },
    enabled && !!providerId
  );
}
